import React, { useState, useEffect } from 'react';
import { Dialog } from "primereact/dialog";
import { InputNumber } from "primereact/inputnumber";
import { InputText } from "primereact/inputtext";
import { FloatLabel } from "primereact/floatlabel";
import { Link, Navigate, resolvePath } from "react-router-dom";
import { config } from "../shared/config";
import * as util from '../shared/commons';
import axios from "axios";
import { Button } from 'primereact/button';
import 'primeicons/primeicons.css';
import { Image } from "primereact/image";
import ShowError from "../shared/ShowError";
import ShowConfirm from "../shared/ShowConfirm";
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Skeleton } from 'primereact/skeleton';
import { Toast } from 'primereact/toast';
import GeneralDialogFooter from '../shared/GeneralDialogFooter';
import SchoolCombo from "../combos/SchoolCombo";


export default function DisorderTypes(props) {
  const [redirectUrl, setRedirectUrl] = useState("");
  const [errorVisible, setErorVisible] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [saving, setSaving] = useState(false);
  const [deleting, setDeleting] = useState(false);
  const [loading, setLoading] = useState(false);
  const [confirmDeleteVisible, setConfirmDeleteVisible] = useState(false);
  const [confirmAcceptVisible, setConfirmAcceptVisible] = useState(false);
  const [school, setSchool] = useState({});
  const [listVisible, setlistVisible] = useState(false);
  const [creditorSum, setCreditorSum] = useState("");
  const [debtorSum, setDebtorSum] = useState("");
  const [remainSum, setRemainSum] = useState("");
  const [remainState, setRemainState] = useState("");




  const [currentItem, setCurrentItem] = useState(null);
  const [items, setItems] = useState([]);
  const [filterItems, setFilterItems] = useState([]);
  const LoadingRows = Array.from({ length: 5 });

  useEffect(() => {

  }, []);
  const loadItems = function () {
    setlistVisible(true);
    console.log("school is-->", school);
    var params = { login: util.getTrustedUser(), schoolId: school.id };
    var url = config.Server + `/payment/school/bill`;
    console.log("params is>", params);
    console.log("url is>", url);
    axios
      .post(url, params)
      .then(res => {
        var response = res.data;
        if (response.state === "ok") {
          response = response.data;
          console.log("response is>", response);
          console.log("creditorsum-->", response.creditorSum);
          setCreditorSum(response.creditorSum);
          setDebtorSum(response.debtorSum);
          setRemainSum(response.remainSum);
          setRemainState(response.state);
          setItems(response.rows);
          setFilterItems(response.rows);

          setLoading(false);

        }
        else {
          setErrorMessage(response.message);
          setErorVisible(true);
          setSaving(false);
        }
      })
      .catch(error => {
        setErrorMessage(error.code + "," + error.message);
        setErorVisible(true);
        setSaving(false);
      });
  }

  const onComboChange = function (name, value) {
    if (name === "school") {
      setSchool(value);
    }
    console.log(school);
    return
  }


  return (
    <>
      <div className="card">
        <div className="page-caption">لیست  صورت حساب های مدرسه</div>
        {
          <div className="card" style={{ width: "300px", borderBlockColor: "#414141" }}>
            <table style={{ width: "100%" }}>
              <tbody>
                <tr><td colSpan={2}>&nbsp;</td></tr>
                <tr>
                  <td colSpan={2}>
                    <SchoolCombo returnFullItem={true} includeActive={true} includeInActive={true} value={school} onChange={(val) => onComboChange('school', val)} />
                  </td>
                </tr>
                <tr>
                  <td>
                    <div className="card flex justify-content-center" style={{ direction: "ltr", textAlign: "right", paddingTop: "40px" }}>
                      <Button label="دریافت صورت حساب" icon="pi pi-search" onClick={() => loadItems()} severity="primary" iconPos="right" loading={saving} style={{ width: "250px" }} />
                    </div>
                  </td>
                </tr>
                <tr><td colSpan={2}>&nbsp;</td></tr>
              </tbody>
            </table>
          </div>
        }
        {
          listVisible ?
            <table style={{ borderCollapse: "collapse", width: "500px" }} >
              <tbody>
                <tr>
                  <td style={{ border: "1px solid #adadadff", height: "50px", textAlign: "center", backgroundColor: "#eee2fdff" }}>
                    مقدار بستانکاری
                  </td>
                  <td style={{ border: "1px solid #adadadff", height: "50px", textAlign: "center", backgroundColor: "#eee2fdff" }} keyfilter="int">
                    {util.SeperatePrice(creditorSum)}
                  </td>
                </tr>
                <tr>
                  <td style={{ border: "1px solid #adadadff", height: "50px", textAlign: "center", backgroundColor: "#ebebebff" }}>
                    مقدار بدهکاری
                  </td>
                  <td style={{ border: "1px solid #adadadff", height: "50px", textAlign: "center", backgroundColor: "#ebebebff" }} keyfilter="int">
                    {util.SeperatePrice(debtorSum)}
                  </td>
                </tr>
                <tr>
                  <td style={{ border: "1px solid #adadadff", height: "50px", textAlign: "center", backgroundColor: "#eee2fdff" }}>
                    مقدار باقی مانده
                  </td>
                  <td style={{ border: "1px solid #adadadff", height: "50px", textAlign: "center", backgroundColor: "#eee2fdff" }} keyfilter="int">
                    {util.SeperatePrice(remainSum)}
                  </td>
                </tr>
                <tr>
                  <td style={{ border: "1px solid #adadadff", height: "50px", textAlign: "center", backgroundColor: "#ebebebff" }}>
                    وضعیت
                  </td>
                  <td style={{ border: "1px solid #adadadff", height: "50px", textAlign: "center", backgroundColor: "#ebebebff" }} keyfilter="int">
                    {remainState}
                  </td>
                </tr>
                <tr><td colSpan={2}>&nbsp;</td></tr>
              </tbody>
            </table>
            :
            <>
            </>
        }
        {
          listVisible ?
            <DataTable value={filterItems} selectionMode={true ? null : 'radiobutton'} scrollable tableStyle={{ minWidth: '50rem' }} size="small" stripedRows paginator rows={50} rowsPerPageOptions={[50, 100, 200, 500]}
              paginatorTemplate="FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink RowsPerPageDropdown "
              currentPageReportTemplate="{first} تا {last} از {totalRecords}"
              dataKey="id" selection={currentItem} onSelectionChange={(e) => { setCurrentItem(e.value) }}>
              <Column selectionMode="single" headerStyle={{ width: '3rem' }}></Column>
              <Column header="#" headerStyle={{ width: '3rem' }} body={(data, options) => options.rowIndex + 1} className="list-cell-text-align"></Column>
              <Column field="issueDate" header={"تاریخ"} sortable className="list-cell-text-align"></Column>
              <Column field="comment" header={"شرح"} sortable className="list-cell-text-align"></Column>
              <Column field="debtor" header={"بدهکار"} sortable className="list-cell-text-align"></Column>
              <Column field="creditor" header={"بستانکار"} sortable className="list-cell-text-align"></Column>
            </DataTable>
            :
            <>
            </>
        }
      </div>
    </>
  );
}
